var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"stretch","align-content":"start","justify":"center","no-gutters":""}},[_c('v-col',[_c('ButtonGenerator')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }